export class LearndashProgress {
  public ID: string;

  public numOfCompletedSteps: number;

  public totalSteps: number;

  public completed: boolean;
}
